import CollectionBannerCarousel from '@/modules/collection-banner';

document.querySelectorAll('.js-collection-banner-carousel').forEach((collectionBannerCarousel) => {
    new CollectionBannerCarousel(collectionBannerCarousel);
});
